import React from "react";
import { BenefitItemProps, DetailItemProps } from "../@types";

const ItemIterator = ({
  children: items,
  Component,
  ...props
}: {
  children: Array<BenefitItemProps | DetailItemProps>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.FunctionComponent<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}): any => (
  <>
    {items.map((itemProps, i) => (
      <Component key={i} {...itemProps} {...props} />
    ))}
  </>
);

export default ItemIterator;
